module.exports = __webpack_public_path__ + "static/img/file3.192f358.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/file3.png
// module id = PTGB
// module chunks = 1